export var LOOP_RENDERER_TYPE = "LOOP";
var strategy = function (block, callback, contentState) {
    block.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === LOOP_RENDERER_TYPE);
    }, callback);
};
// eslint-disable-next-line import/no-default-export
export default strategy;
